/**
 * After a BRD/document upload the backend now returns the full hours estimation directly
 * (slot="estimation.final"). This helper is kept for any legacy intermediate steps that
 * may still occur (e.g. modules/features markdown from older flows).
 */

const MAX_BRD_CHAIN_DEPTH = 12;

function hasFullEstimationReply({ aiReply, responseSlot, estimationValue }) {
  if (responseSlot === "estimation.final") return true;
  if (
    estimationValue &&
    typeof estimationValue === "object" &&
    Object.keys(estimationValue).length > 0
  ) {
    return true;
  }
  const lower = (aiReply || "").toLowerCase();
  if (lower.includes("total estimated hours") || lower.includes("total hours")) {
    return true;
  }
  if (
    aiReply.includes("Project Estimation & Scope of Work") ||
    aiReply.includes("🚀 **Project Estimation & Scope of Work**")
  ) {
    return true;
  }
  return false;
}

function isModulesFeaturesMarkdown(aiReply) {
  if (!aiReply || typeof aiReply !== "string") return false;
  return (
    (aiReply.includes("Modules:") && aiReply.includes("Project Scope:")) ||
    (aiReply.includes("Project Scope:") &&
      (aiReply.includes("Frontend:") ||
        aiReply.includes("Backend/API:") ||
        aiReply.includes("Core API and Admin Backend:") ||
        aiReply.includes("Admin Panel Frontend:") ||
        aiReply.includes("UI/UX:")))
  );
}

/**
 * @returns {{ kind: 'continue' } | null}
 */
export function getBrdAutoAdvanceAction(
  { aiReply, responseSlot, estimationValue },
  depth = 0
) {
  if (depth >= MAX_BRD_CHAIN_DEPTH) return null;

  const payload = { aiReply, responseSlot, estimationValue };
  if (hasFullEstimationReply(payload)) return null;

  if (isModulesFeaturesMarkdown(aiReply)) {
    return { kind: "continue" };
  }

  return null;
}
